module.exports = __webpack_public_path__ + "img/logo-creditu.77e57ca0.svg";